import { ViolationStatus } from '@/api/rentalscape/__generated_types__/graphql';
import dayjs from 'dayjs';
import { ViolationNode } from '../types';

export function generateViolationClosureMessage(violation: ViolationNode) {
  if (violation.status === ViolationStatus.Closed) {
    return `Violation closed on ${dayjs.unix(violation.modified).format('MM-DD-YYYY')}`;
  }

  return null;
}
